/**
 * Validation for CreateStory form. Returns first error message or null when valid.
 * Magic numbers (file size) live here as named constants for clarity.
 */
export const MAX_PHOTO_BYTES = 6 * 1024 * 1024; // 6 MB

export function validatePhotoFile(file) {
    if (!file) return "Please select a photo.";
    if (file.size > MAX_PHOTO_BYTES) return "Photo must be under 6 MB.";
    return null;
}

export function validateStoryForm({ childName, theme, lesson, addr }) {
    if (!childName?.trim() || !theme?.trim() || !lesson?.trim()) {
        return "Please fill in your child's name, theme and lesson.";
    }
    if (!addr.line1 || !addr.city || !addr.state || !addr.postal_code) {
        return "Please complete the shipping address.";
    }
    return null;
}
